module.exports = __webpack_public_path__ + "img/icon-16-ic-node.caf14ce2.svg";